import React, { Fragment, useRef, useState, useEffect } from "react";
import close from "../../../assets/images/model/close.svg";
import filePlus from "../../../assets/images/model/upload_arrow.svg";
import infoCreate from "../../../assets/images/model/info-create.svg";
import polygonArrow from "../../../assets/images/model/Polygon-dowan-arrow.svg";
import AudioPlayer, { RHAP_UI } from "react-h5-audio-player";
import "react-h5-audio-player/lib/styles.css";

const AudioUploadQ = ({ setShowAudioUploadModal, onAudioUploadedQ }) => {
  const [uploadAudio, setUploadAudio] = useState(true);
  const [uploadLoadedAudio, setUploadLoadedAudio] = useState(false);
  const [audioFile, setAudioFile] = useState(null);
  const [audioDuration, setAudioDuration] = useState(null);
  const [isLoading, setIsLoading] = useState(false);
  const [uploadProgress, setUploadProgress] = useState(0);
  const audioRef = useRef();
  const dropRef = useRef();
  const circleRef = useRef();

  const handleLoadedMetadata = () => {
    if (audioRef.current && audioRef.current.audio.current) {
      const duration = audioRef.current.audio.current.duration;
      setAudioDuration(duration);
    }
  };

  useEffect(() => {
    const items = document.querySelectorAll(".progress-item");

    const newIntervals = Array.from(items).map((_, index) => {
      return setInterval(() => {
        const updatedPercentage = (uploadProgress / 100) * 100;

        items[
          index
        ].style.background = `conic-gradient(var(--Purple-700, #6700B2) calc(${updatedPercentage}%),var(--Purple-300, #DDD5EB) 0deg)`;
        items[index].setAttribute("data-value", `${updatedPercentage}%`);
        items[index].textContent = `${updatedPercentage}%`;

        if (uploadProgress === 100) {
          clearInterval(newIntervals[index]);
        }
      }, 15);
    });

    return () => {
      newIntervals.forEach((interval) => clearInterval(interval));
    };
  }, [uploadProgress]);

  const handleUpload = (file) => {
    if (file) {
      setIsLoading(true);
      let progress = 0;

      const interval = setInterval(() => {
        progress += 20;
        setUploadProgress(progress);

        if (progress >= 100) {
          clearInterval(interval);
          setTimeout(() => {
            setAudioFile(file);
            setUploadAudio(false);
            setUploadLoadedAudio(true);
            setIsLoading(false);
          }, 500);
        }
      }, 500);
    }
  };

  const handleClose = () => {
    setShowAudioUploadModal(false);
  };

  const handleFileUpload = () => {
    onAudioUploadedQ(audioFile);
    setShowAudioUploadModal(false);
  };

  const formatTime = (time) => {
    if (!time) return "0:00";
    const minutes = Math.floor(time / 60);
    const seconds = Math.floor(time % 60);
    return `${minutes}:${seconds < 10 ? "0" : ""}${seconds}`;
  };

  const handleDragOver = (event) => {
    event.preventDefault();
    event.stopPropagation();
    dropRef.current.classList.add("drag-over");
  };

  const handleDragEnter = (event) => {
    event.preventDefault();
    event.stopPropagation();
    dropRef.current.classList.add("drag-over");
  };

  const handleDragLeave = (event) => {
    event.preventDefault();
    event.stopPropagation();
    dropRef.current.classList.remove("drag-over");
  };

  const handleDrop = (event) => {
    event.preventDefault();
    event.stopPropagation();
    dropRef.current.classList.remove("drag-over");
    const file = event.dataTransfer.files[0];
    handleUpload(file);
  };

  return (
    <div>
      <div
        className="modal custom_background custom_modal_create"
        id="upload_audio"
        style={{ display: "block" }}
        tabIndex="-1"
        aria-labelledby="upload_audioLabel"
        aria-hidden="true"
      >
        <div className="modal-dialog modal-dialog-centered">
          <div className="modal-content">
            <div className="modal-header">
              <button
                onClick={handleClose}
                type="button"
                className="btn-close"
                data-bs-dismiss="modal"
                aria-label="Close"
              >
                <img src={close} alt="close" />
              </button>
            </div>
            <div className="modal-body-cre">
              <h4>{uploadLoadedAudio ? "Add Audio" : "Upload Audio"}</h4>
              {uploadAudio && !isLoading && (
                <Fragment>
                  <p>
                    Drag and drop an audio file from your computer. Add
                    attribution in the next step.
                  </p>
                  <form action="" className="upload_audio">
                    <div
                      className="upload_audio_inner my-40 mb-0"
                      ref={dropRef}
                      onDragOver={handleDragOver}
                      onDragEnter={handleDragEnter}
                      onDragLeave={handleDragLeave}
                      onDrop={handleDrop}
                    >
                      <div className="drag_and_drop_box" htmlFor="Drag-file">
                        <div className="upload_content">
                          <label
                            htmlFor="Drag-file"
                            style={{ cursor: "pointer" }}
                          >
                            <div className="icon-create mb-24">
                              <img src={filePlus} alt="upload" />
                            </div>
                            <input
                              type="file"
                              id="Drag-file"
                              onChange={(e) => handleUpload(e.target.files[0])}
                              accept="audio/*"
                              style={{ display: "none" }}
                            />
                          </label>

                          <div className="deflat_content">
                            <h6 className="f-size-18 theme__primary__text">
                              <span>Drag and drop file, or </span>
                              <label
                                htmlFor="Drag-file"
                                style={{ cursor: "pointer" }}
                              >
                                Browse
                                <input
                                  type="file"
                                  id="Drag-file"
                                  onChange={(e) =>
                                    handleUpload(e.target.files[0])
                                  }
                                  accept="audio/*"
                                  style={{ display: "none" }}
                                />
                              </label>
                            </h6>
                            <p>Supports mp3 files | Max 50mb size</p>
                          </div>
                        </div>
                      </div>
                    </div>
                  </form>
                </Fragment>
              )}
              {isLoading && (
                <Fragment>
                  <form action="" className="upload_audio">
                    <div className="upload_audio_inner my-40 mb-0">
                      <div
                        className="drag_and_drop_box upload-boarder"
                        htmlFor="Drag-file"
                      >
                        <div className="upload_content">
                          <div className="icon mb-24"> </div>
                          <div className="deflat_content">
                            <div id="progress">
                              <div
                                data-num={uploadProgress}
                                className="progress-item"
                              >
                                {uploadProgress.toFixed(2)}%
                              </div>
                            </div>
                            <h6 className="f-size-18 theme__primary__text">
                              Uploading audio...
                            </h6>
                          </div>
                        </div>
                      </div>
                    </div>
                  </form>
                </Fragment>
              )}

              {uploadLoadedAudio && audioFile && (
                <Fragment>
                  <div className="add_audio_cre">
                    <form action="" className="pick_from_library">
                      <div className="pick_from_library_filter_wrap">
                        <div className="pick_from_library_filter my-40 ">
                          <div className="conten_center my-40 mb-24">
                            <div
                              className="drag_and_drop_box upload-boarder audio_padding"
                              htmlFor="Drag-file"
                            >
                              <div className="deflat_content audio_file_parent">
                                <span className="audio_file">
                                  {audioFile.name}
                                </span>
                                <span className="audio_size">
                                  {formatTime(audioDuration)} (
                                  {Math.round(audioFile.size / (1024 * 1024))}{" "}
                                  MB)
                                </span>
                              </div>

                              <AudioPlayer
                                ref={audioRef}
                                style={{ width: "100%" }}
                                src={URL.createObjectURL(audioFile)}
                                customAdditionalControls={[]}
                                customVolumeControls={[]}
                                showJumpControls={false}
                                customProgressBarSection={[
                                  RHAP_UI.CURRENT_TIME,
                                  <div className="slash_time" key="slash">
                                    /
                                  </div>,
                                  RHAP_UI.DURATION,
                                  RHAP_UI.PROGRESS_BAR,
                                ]}
                                onLoadedMetadata={handleLoadedMetadata}
                              />
                            </div>
                          </div>
                          <div className="icon">
                            <div className="tooltip_wrap Attribution">
                              <h2 className="icon_h2 mb-0">
                                Attribution{" "}
                                <img
                                  src={infoCreate}
                                  className="info_tooltip"
                                  alt="Info"
                                />
                              </h2>
                              <p>
                                Provide the source of the audio to give creator
                                credit <img src={polygonArrow} alt="Polygo" />
                              </p>
                            </div>
                            <input
                              style={{ height: "60px" }}
                              type="text"
                              className="pick_from_input_cre border_color"
                            />
                          </div>
                        </div>
                      </div>
                      <div className="modal-btn">
                        <button
                          type="button"
                          className="btn-black_create"
                          onClick={handleFileUpload}
                        >
                          Done
                        </button>
                      </div>
                    </form>
                  </div>
                </Fragment>
              )}
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default AudioUploadQ;
